import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  // withCredentials: true,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("tokenKey");
        if(token){
            config.headers.Authorization = `Bearer ${token}`
        }
        console.log(`[request] ${config.method.toUpperCase()} - ${config.url}`);
        return config;
    },
    (error) => {
        console.error("[Request Error]", error);
        return Promise.reject(error);
    }
);

    axiosInstance.interceptors.response.use(
        (response) => {
          // Example: transform data or handle standard response format
          return response;
        },
        (error) => {
          // Handle errors globally
          if (error.response) {
            const status = error.response.status;
      
            if (status === 403) {
              // Token expired or unauthorized
              console.warn("Unauthorized! Redirecting to login...");
              window.location.href = "/login";
              localStorage.clear();
            } else if (status === 500) {
              console.error("Server error occurred!");
            }
          } else {
            console.error("Network error:", error.message);
          }
      
          return Promise.reject(error);
        }      
    );

    export default axiosInstance;


// export const axiosPrivate = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE,
// });
